import { PublisherIdFilterContext } from "context/PublisherIdFilterContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const usePublisherIdFilter = () => {
  return useProviderInitializedContext(PublisherIdFilterContext);
};
